import React, {Component} from "react";
import {Header, Footer, Container, Form} from '@deere/ux.uxframe-react';
import CreateCompInfoContainer from "../containers/create-comp-info";

class DisplayDetails extends Component {
    constructor(props) {
        super(props);
        let val = props.match.params.value === 'agree';
        if (val) {
            this.props.showCheck();
        }
    }

    handleClick = event => {
        let valCheck = event.target.checked;
        this.props.changeCheck(valCheck);
    }
    handleClickLink = () => {
        this.props.changeCheckLink();
    }

    newWindowCLick = () => {
        window.open("https://investor.deere.com/governance/default.aspx#_ctrl0_ctl78_divModuleContainer", "Popup", "location,status,scrollbars,resizable,width=800, height=800");
        this.handleClickLink();
    }

    render() {
        return (
            <div>
                <Header inputProps={{
                    ariaLabel: "Search"
                }} submitBtnProps={{
                    ariaLabel: "Search"
                }} clearBtnProps={{
                    ariaLabel: "Clear search"
                }} logoLink="#" pageHeading={"Prospective Supplier"} skipLink="#content" pageHeadingLink="#">
                </Header>
                <div id={"content"} className="container-fluid bg-basic">
                    <Form><br/>
                        <Container className="bg-basic">
                            <h2>John Deere Prospective Supplier Application Form</h2>
                            <h6>
                                We appreciate your interest in becoming a supplier to John Deere. Our company has a
                                robust strategic sourcing process. We maintain a short list of preferred suppliers for
                                each of the categories of goods and services we procure. We have long term contracts in
                                place with our significant suppliers. Opportunities to add new suppliers occur
                                occasionally as our business needs change.<br/><br/>
                                To ensure that all of our suppliers conduct business with a high degree of integrity and
                                in a socially and environmentally responsible manner, we hold them to the John Deere
                                Supplier Code of Conduct.
                            </h6>
                            <input
                                type={"checkbox"}
                                id={"chckBox"}
                                name={"chckBox"}
                                className={"col-xs-10"}
                                checked={this.props.checked}
                                onChange={this.handleClick}
                            />&nbsp;
                            I Agree to follow the <a target="_blank" rel="noopener noreferrer"
                                                     onClick={this.newWindowCLick} className="badge badge-default"
                                                     ><h6>John Deere Supplier Code Of Conduct</h6></a>
                            <div id="results">
                                {this.props.checked ? <CreateCompInfoContainer/> : null}
                            </div>
                        </Container>
                    </Form>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default DisplayDetails;